// extracted by mini-css-extract-plugin
module.exports = {"content-500":"content-500","container":"container","link":"link"};